/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common/component/rich_text';
import '../common/workflow/screens/additional_card';
import '../../common/countries';
import '../common/workflow/ui_elements/common';
import './debit_card_management';
import './card_management_configuration';
import './digital_wallet_snapshot';
import './onboarding_splash';
import './flow';
import './debit_card_data';
import '../../common/currency';
import './banking_home_sections';
import '../common/workflow/screens/digital_wallet_configuration';
import './bill_pay';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "ActiveIncentiveProgramProgressRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "ActiveIncentiveProgramProgressResponse": {
                    "fields": {
                      "incentiveProgram": {
                        "type": ".squareup.bbfrontend.service.v1.ActiveIncentiveProgramProgressResponse.ActiveIncentiveProgram",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ActiveIncentiveProgram": {
                        "fields": {
                          "title": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "percentage": {
                            "type": "double",
                            "id": 2,
                            "rule": "optional"
                          },
                          "inProgress": {
                            "type": ".squareup.bbfrontend.service.v1.ActiveIncentiveProgramProgressResponse.ActiveIncentiveProgram.InProgress",
                            "id": 3
                          },
                          "completed": {
                            "type": ".squareup.bbfrontend.service.v1.ActiveIncentiveProgramProgressResponse.ActiveIncentiveProgram.Completed",
                            "id": 4
                          }
                        },
                        "nested": {
                          "InProgress": {
                            "fields": {
                              "progressText": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "daysLeftText": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "Completed": {
                            "fields": {
                              "completedText": {
                                "type": ".squareup.bbfrontend.common.component.RichText",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "details": {
                            "oneof": ["inProgress", "completed"]
                          }
                        }
                      }
                    }
                  },
                  "GetCardAssignmentCandidatesRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetCardAssignmentCandidatesResponse": {
                    "fields": {
                      "candidates": {
                        "type": ".squareup.bbfrontend.service.v1.CardAssignmentCandidate",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "CreateCardInvitationRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "selectedCandidate": {
                        "type": ".squareup.bbfrontend.service.v1.CardAssignmentCandidate",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreateCardInvitationResponse": {
                    "fields": {
                      "success": {
                        "type": ".squareup.bbfrontend.service.v1.CreateCardInvitationResponse.Success",
                        "id": 1
                      },
                      "error": {
                        "type": ".squareup.bbfrontend.service.v1.CreateCardInvitationResponse.Error",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Success": {
                        "fields": {
                          "cardInvitationToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "Error": {
                        "fields": {
                          "errorType": {
                            "type": ".squareup.bbfrontend.service.v1.CreateCardInvitationResponse.Error.ErrorType",
                            "id": 1,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "ErrorType": {
                            "values": {
                              "INVALID_EMAIL": 0,
                              "INVALID_FIRST_NAME": 1,
                              "INVALID_LAST_NAME": 2,
                              "SUBMITTED_CANDIDATE_COULD_NOT_BE_PARSED": 3,
                              "EMAIL_USED_ALREADY": 4
                            }
                          }
                        }
                      },
                      "result": {
                        "oneof": ["success", "error"]
                      }
                    }
                  },
                  "DebitCardActivationUpsellRequest": {
                    "fields": {
                      "unitTokens": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "DebitCardActivationUpsellResponse": {
                    "fields": {
                      "unitTokens": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "activatableCards": {
                        "type": ".squareup.bbfrontend.service.v1.DebitCardActivationUpsellResponse.ActivatableCard",
                        "id": 7,
                        "rule": "repeated"
                      },
                      "upsellTitle": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "buttonTitle": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "countryCode": {
                        "type": ".squareup.common.countries.Country",
                        "id": 4,
                        "rule": "optional"
                      },
                      "viewLogEvent": {
                        "type": ".squareup.bbfrontend.service.v1.LogEvent",
                        "id": 5,
                        "rule": "optional"
                      },
                      "clickLogEvent": {
                        "type": ".squareup.bbfrontend.service.v1.LogEvent",
                        "id": 6,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ActivatableCard": {
                        "fields": {
                          "unitToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "activatableCardToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "DebitCardManagementConfigurationRequest": {
                    "fields": {
                      "context": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "unitToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "cardToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "clientCapableFlows": {
                        "type": ".squareup.bbfrontend.service.v1.DebitCardManagement.ClientCapableFlow",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "configuration": {
                        "type": ".squareup.bbfrontend.service.v1.CardManagementConfiguration",
                        "id": 5,
                        "rule": "optional"
                      },
                      "digitalWalletSnapshot": {
                        "type": ".squareup.bbfrontend.service.v1.DigitalWalletSnapshot",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  },
                  "DebitCardManagementConfigurationResponse": {
                    "fields": {
                      "context": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "unitToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "onboard": {
                        "type": ".squareup.bbfrontend.service.v1.DebitCardManagementConfigurationResponse.Onboard",
                        "id": 3
                      },
                      "manage": {
                        "type": ".squareup.bbfrontend.service.v1.DebitCardManagementConfigurationResponse.Manage",
                        "id": 4
                      }
                    },
                    "nested": {
                      "Onboard": {
                        "fields": {
                          "title": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "product": {
                            "type": ".squareup.bbfrontend.service.v1.DebitCardManagementConfigurationResponse.Onboard.Product",
                            "id": 2,
                            "rule": "optional"
                          },
                          "splash": {
                            "type": ".squareup.bbfrontend.service.v1.OnboardingSplash",
                            "id": 3,
                            "rule": "optional"
                          },
                          "onboardingFlow": {
                            "type": ".squareup.bbfrontend.service.v1.Flow.CheckingOnboarding",
                            "id": 4,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Product": {
                            "values": {
                              "PRODUCT_US_CHECKING": 0,
                              "PRODUCT_CA_SQUARE_CARD": 1
                            }
                          }
                        }
                      },
                      "Manage": {
                        "fields": {
                          "cardData": {
                            "type": ".squareup.bbfrontend.service.v1.DebitCardData",
                            "id": 1,
                            "rule": "optional"
                          },
                          "configuration": {
                            "type": ".squareup.bbfrontend.service.v1.CardManagementConfiguration",
                            "id": 2,
                            "rule": "optional"
                          },
                          "toast": {
                            "type": ".squareup.bbfrontend.service.v1.Toast",
                            "id": 3,
                            "rule": "optional"
                          },
                          "interstitialFlow": {
                            "type": ".squareup.bbfrontend.service.v1.DebitCardManagement.ClientHandleableFlow",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "response": {
                        "oneof": ["onboard", "manage"]
                      }
                    }
                  },
                  "CreditCardHomeConfigurationRequest": {
                    "fields": {
                      "creditLineId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreditCardHomeConfigurationResponse": {
                    "fields": {
                      "creditLineId": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "cardManagementContext": {
                        "type": "bytes",
                        "id": 4,
                        "rule": "optional"
                      },
                      "configuration": {
                        "type": ".squareup.bbfrontend.service.v1.CardManagementConfiguration",
                        "id": 1
                      },
                      "onboardingSplash": {
                        "type": ".squareup.bbfrontend.service.v1.OnboardingSplash",
                        "id": 2
                      }
                    },
                    "nested": {
                      "screen": {
                        "oneof": ["configuration", "onboardingSplash"]
                      }
                    }
                  },
                  "CreditCardHomeAvailabilityRequest": {
                    "fields": {}
                  },
                  "CreditCardHomeAvailabilityResponse": {
                    "fields": {
                      "existing": {
                        "type": ".squareup.bbfrontend.service.v1.CreditCardHomeAvailabilityResponse.ExistingCreditCard",
                        "id": 1
                      },
                      "offer": {
                        "type": ".squareup.bbfrontend.service.v1.CreditCardHomeAvailabilityResponse.Offer",
                        "id": 2
                      }
                    },
                    "nested": {
                      "ExistingCreditCard": {
                        "fields": {
                          "creditLineId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "Offer": {
                        "fields": {
                          "creditLineAmount": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "hasStartedApplication": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "response": {
                        "oneof": ["existing", "offer"]
                      }
                    }
                  },
                  "CreditCardBankingHomeSectionRequest": {
                    "fields": {}
                  },
                  "CreditCardBankingHomeSectionResponse": {
                    "fields": {
                      "legalFooterText": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "existing": {
                        "type": ".squareup.bbfrontend.service.v1.BankingHomeCreditCardSection",
                        "id": 1
                      },
                      "application": {
                        "type": ".squareup.bbfrontend.service.v1.BankingHomeCreditCardApplication",
                        "id": 2
                      }
                    },
                    "nested": {
                      "section": {
                        "oneof": ["existing", "application"]
                      }
                    }
                  },
                  "CardManagementConfigurationRequest": {
                    "fields": {
                      "context": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "configuration": {
                        "type": ".squareup.bbfrontend.service.v1.CardManagementConfiguration",
                        "id": 3,
                        "rule": "optional"
                      },
                      "digitalWalletSnapshot": {
                        "type": ".squareup.bbfrontend.service.v1.DigitalWalletSnapshot",
                        "id": 4,
                        "rule": "optional"
                      },
                      "creditCard": {
                        "type": ".squareup.bbfrontend.service.v1.CardManagementConfigurationRequest.CreditCard",
                        "id": 2
                      }
                    },
                    "nested": {
                      "CreditCard": {
                        "fields": {
                          "creditLineId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "clientCapabilities": {
                            "type": ".squareup.bbfrontend.service.v1.CardManagementConfigurationRequest.CreditCard.ClientCapabilities",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "ClientCapabilities": {
                            "fields": {
                              "canAddToDigitalWallet": {
                                "type": "bool",
                                "id": 1,
                                "rule": "optional"
                              },
                              "canRenderCreditSettings": {
                                "type": "bool",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "card": {
                        "oneof": ["creditCard"]
                      }
                    }
                  },
                  "CardManagementConfigurationResponse": {
                    "fields": {
                      "context": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "manage": {
                        "type": ".squareup.bbfrontend.service.v1.CardManagementConfigurationResponse.Manage",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Manage": {
                        "fields": {
                          "configuration": {
                            "type": ".squareup.bbfrontend.service.v1.CardManagementConfiguration",
                            "id": 1,
                            "rule": "optional"
                          },
                          "toast": {
                            "type": ".squareup.bbfrontend.service.v1.Toast",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "response": {
                        "oneof": ["manage"]
                      }
                    }
                  },
                  "ProvisionDigitalWalletRequest": {
                    "fields": {
                      "source": {
                        "type": ".squareup.bbfrontend.service.v1.ProvisionDigitalWalletRequest.Source",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": "PROVISION_DIGITAL_WALLET_SOURCE_APP"
                        }
                      },
                      "creditCard": {
                        "type": ".squareup.bbfrontend.service.v1.ProvisionDigitalWalletRequest.CreditCard",
                        "id": 1
                      },
                      "debitCard": {
                        "type": ".squareup.bbfrontend.service.v1.ProvisionDigitalWalletRequest.DebitCard",
                        "id": 3
                      },
                      "applePayRequest": {
                        "type": ".squareup.bbfrontend.service.v1.DigitalWalletProvisionApplePayRequest",
                        "id": 2
                      }
                    },
                    "nested": {
                      "CreditCard": {
                        "fields": {
                          "cardToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "DebitCard": {
                        "fields": {
                          "cardToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "Source": {
                        "values": {
                          "PROVISION_DIGITAL_WALLET_SOURCE_APP": 0,
                          "PROVISION_DIGITAL_WALLET_SOURCE_WALLET_EXTENSION": 1
                        }
                      },
                      "card": {
                        "oneof": ["creditCard", "debitCard"]
                      },
                      "provider_request": {
                        "oneof": ["applePayRequest"]
                      }
                    }
                  },
                  "ProvisionDigitalWalletResponse": {
                    "fields": {
                      "success": {
                        "type": ".squareup.bbfrontend.service.v1.ProvisionDigitalWalletResponse.Success",
                        "id": 1
                      },
                      "failure": {
                        "type": ".squareup.bbfrontend.service.v1.ProvisionDigitalWalletResponse.Failure",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Success": {
                        "fields": {
                          "applePayResponse": {
                            "type": ".squareup.bbfrontend.service.v1.DigitalWalletProvisionApplePayResponse",
                            "id": 1
                          }
                        },
                        "nested": {
                          "provider_response": {
                            "oneof": ["applePayResponse"]
                          }
                        }
                      },
                      "Failure": {
                        "fields": {}
                      },
                      "result": {
                        "oneof": ["success", "failure"]
                      }
                    }
                  },
                  "BbFrontendClientService": {
                    "methods": {
                      "GetActiveIncentiveProgramProgress": {
                        "requestType": ".squareup.bbfrontend.service.v1.ActiveIncentiveProgramProgressRequest",
                        "responseType": ".squareup.bbfrontend.service.v1.ActiveIncentiveProgramProgressResponse"
                      },
                      "GetCardAssignmentCandidates": {
                        "requestType": ".squareup.bbfrontend.service.v1.GetCardAssignmentCandidatesRequest",
                        "responseType": ".squareup.bbfrontend.service.v1.GetCardAssignmentCandidatesResponse"
                      },
                      "CreateCardInvitation": {
                        "requestType": ".squareup.bbfrontend.service.v1.CreateCardInvitationRequest",
                        "responseType": ".squareup.bbfrontend.service.v1.CreateCardInvitationResponse"
                      },
                      "GetDebitCardActivationUpsell": {
                        "requestType": ".squareup.bbfrontend.service.v1.DebitCardActivationUpsellRequest",
                        "responseType": ".squareup.bbfrontend.service.v1.DebitCardActivationUpsellResponse"
                      },
                      "GetDebitCardManagementConfiguration": {
                        "requestType": ".squareup.bbfrontend.service.v1.DebitCardManagementConfigurationRequest",
                        "responseType": ".squareup.bbfrontend.service.v1.DebitCardManagementConfigurationResponse"
                      },
                      "GetCreditCardHomeAvailability": {
                        "requestType": ".squareup.bbfrontend.service.v1.CreditCardHomeAvailabilityRequest",
                        "responseType": ".squareup.bbfrontend.service.v1.CreditCardHomeAvailabilityResponse"
                      },
                      "GetCreditCardBankingHomeSection": {
                        "requestType": ".squareup.bbfrontend.service.v1.CreditCardBankingHomeSectionRequest",
                        "responseType": ".squareup.bbfrontend.service.v1.CreditCardBankingHomeSectionResponse"
                      },
                      "GetCreditCardHomeConfiguration": {
                        "requestType": ".squareup.bbfrontend.service.v1.CreditCardHomeConfigurationRequest",
                        "responseType": ".squareup.bbfrontend.service.v1.CreditCardHomeConfigurationResponse"
                      },
                      "GetCardManagementConfiguration": {
                        "requestType": ".squareup.bbfrontend.service.v1.CardManagementConfigurationRequest",
                        "responseType": ".squareup.bbfrontend.service.v1.CardManagementConfigurationResponse"
                      },
                      "GetBillPayData": {
                        "requestType": ".squareup.bbfrontend.service.v1.GetBillPayDataRequest",
                        "responseType": ".squareup.bbfrontend.service.v1.GetBillPayDataConfigurationResponse"
                      },
                      "GetBillPayAvailability": {
                        "requestType": ".squareup.bbfrontend.service.v1.BillPayAvailabilityRequest",
                        "responseType": ".squareup.bbfrontend.service.v1.BillPayAvailabilityResponse"
                      },
                      "ProvisionDigitalWallet": {
                        "requestType": ".squareup.bbfrontend.service.v1.ProvisionDigitalWalletRequest",
                        "responseType": ".squareup.bbfrontend.service.v1.ProvisionDigitalWalletResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ActiveIncentiveProgramProgressRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ActiveIncentiveProgramProgressResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ActiveIncentiveProgramProgressResponse?.nested?.ActiveIncentiveProgram && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ActiveIncentiveProgramProgressResponse?.nested?.ActiveIncentiveProgram?.nested?.InProgress && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ActiveIncentiveProgramProgressResponse?.nested?.ActiveIncentiveProgram?.nested?.Completed && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetCardAssignmentCandidatesRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetCardAssignmentCandidatesResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreateCardInvitationRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreateCardInvitationResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreateCardInvitationResponse?.nested?.Success && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreateCardInvitationResponse?.nested?.Error && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreateCardInvitationResponse?.nested?.Error?.nested?.ErrorType && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DebitCardActivationUpsellRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DebitCardActivationUpsellResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DebitCardActivationUpsellResponse?.nested?.ActivatableCard && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DebitCardManagementConfigurationRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DebitCardManagementConfigurationResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DebitCardManagementConfigurationResponse?.nested?.Onboard && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DebitCardManagementConfigurationResponse?.nested?.Onboard?.nested?.Product && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DebitCardManagementConfigurationResponse?.nested?.Manage && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreditCardHomeConfigurationRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreditCardHomeConfigurationResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreditCardHomeAvailabilityRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreditCardHomeAvailabilityResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreditCardHomeAvailabilityResponse?.nested?.ExistingCreditCard && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreditCardHomeAvailabilityResponse?.nested?.Offer && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreditCardBankingHomeSectionRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CreditCardBankingHomeSectionResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CardManagementConfigurationRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CardManagementConfigurationRequest?.nested?.CreditCard && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CardManagementConfigurationRequest?.nested?.CreditCard?.nested?.ClientCapabilities && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CardManagementConfigurationResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CardManagementConfigurationResponse?.nested?.Manage && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ProvisionDigitalWalletRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ProvisionDigitalWalletRequest?.nested?.CreditCard && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ProvisionDigitalWalletRequest?.nested?.DebitCard && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ProvisionDigitalWalletRequest?.nested?.Source && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ProvisionDigitalWalletResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ProvisionDigitalWalletResponse?.nested?.Success && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ProvisionDigitalWalletResponse?.nested?.Failure && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BbFrontendClientService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ActiveIncentiveProgramProgressRequest @ squareup/bbfrontend/v1/client_service.proto at 28:1
 */
export const ActiveIncentiveProgramProgressRequest = $root.lookupType('squareup.bbfrontend.service.v1.ActiveIncentiveProgramProgressRequest');
fixType(ActiveIncentiveProgramProgressRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ActiveIncentiveProgramProgressRequest);
/**
 * SOURCE ActiveIncentiveProgramProgressResponse @ squareup/bbfrontend/v1/client_service.proto at 32:1
 */
export const ActiveIncentiveProgramProgressResponse = $root.lookupType('squareup.bbfrontend.service.v1.ActiveIncentiveProgramProgressResponse');
fixType(ActiveIncentiveProgramProgressResponse);
Builder.createAndAttachToType(ActiveIncentiveProgramProgressResponse);
/**
 * SOURCE ActiveIncentiveProgram @ squareup/bbfrontend/v1/client_service.proto at 35:3
 */
ActiveIncentiveProgramProgressResponse.ActiveIncentiveProgram = $root.lookupType('squareup.bbfrontend.service.v1.ActiveIncentiveProgramProgressResponse.ActiveIncentiveProgram');
fixType(ActiveIncentiveProgramProgressResponse.ActiveIncentiveProgram, {
  title: {
    notEmpty: true
  },
  percentage: {
    required: true
  }
});
Builder.createAndAttachToType(ActiveIncentiveProgramProgressResponse.ActiveIncentiveProgram);
/**
 * SOURCE InProgress @ squareup/bbfrontend/v1/client_service.proto at 44:5
 */
ActiveIncentiveProgramProgressResponse.ActiveIncentiveProgram.InProgress = $root.lookupType('squareup.bbfrontend.service.v1.ActiveIncentiveProgramProgressResponse.ActiveIncentiveProgram.InProgress');
fixType(ActiveIncentiveProgramProgressResponse.ActiveIncentiveProgram.InProgress, {
  progressText: {
    notEmpty: true
  },
  daysLeftText: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ActiveIncentiveProgramProgressResponse.ActiveIncentiveProgram.InProgress);
/**
 * SOURCE Completed @ squareup/bbfrontend/v1/client_service.proto at 49:5
 */
ActiveIncentiveProgramProgressResponse.ActiveIncentiveProgram.Completed = $root.lookupType('squareup.bbfrontend.service.v1.ActiveIncentiveProgramProgressResponse.ActiveIncentiveProgram.Completed');
fixType(ActiveIncentiveProgramProgressResponse.ActiveIncentiveProgram.Completed, {
  completedText: {
    required: true
  }
});
Builder.createAndAttachToType(ActiveIncentiveProgramProgressResponse.ActiveIncentiveProgram.Completed);
/**
 * SOURCE GetCardAssignmentCandidatesRequest @ squareup/bbfrontend/v1/client_service.proto at 55:1
 */
export const GetCardAssignmentCandidatesRequest = $root.lookupType('squareup.bbfrontend.service.v1.GetCardAssignmentCandidatesRequest');
fixType(GetCardAssignmentCandidatesRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetCardAssignmentCandidatesRequest);
/**
 * SOURCE GetCardAssignmentCandidatesResponse @ squareup/bbfrontend/v1/client_service.proto at 60:1
 */
export const GetCardAssignmentCandidatesResponse = $root.lookupType('squareup.bbfrontend.service.v1.GetCardAssignmentCandidatesResponse');
fixType(GetCardAssignmentCandidatesResponse, {
  candidates: {
    required: true
  }
});
Builder.createAndAttachToType(GetCardAssignmentCandidatesResponse);
/**
 * SOURCE CreateCardInvitationRequest @ squareup/bbfrontend/v1/client_service.proto at 65:1
 */
export const CreateCardInvitationRequest = $root.lookupType('squareup.bbfrontend.service.v1.CreateCardInvitationRequest');
fixType(CreateCardInvitationRequest, {
  unitToken: {
    notEmpty: true
  },
  selectedCandidate: {
    required: true
  }
});
Builder.createAndAttachToType(CreateCardInvitationRequest);
/**
 * SOURCE CreateCardInvitationResponse @ squareup/bbfrontend/v1/client_service.proto at 77:1
 */
export const CreateCardInvitationResponse = $root.lookupType('squareup.bbfrontend.service.v1.CreateCardInvitationResponse');
fixType(CreateCardInvitationResponse);
Builder.createAndAttachToType(CreateCardInvitationResponse);
/**
 * SOURCE Success @ squareup/bbfrontend/v1/client_service.proto at 83:3
 */
CreateCardInvitationResponse.Success = $root.lookupType('squareup.bbfrontend.service.v1.CreateCardInvitationResponse.Success');
fixType(CreateCardInvitationResponse.Success, {
  cardInvitationToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateCardInvitationResponse.Success);
/**
 * SOURCE Error @ squareup/bbfrontend/v1/client_service.proto at 87:3
 */
CreateCardInvitationResponse.Error = $root.lookupType('squareup.bbfrontend.service.v1.CreateCardInvitationResponse.Error');
fixType(CreateCardInvitationResponse.Error, {
  errorType: {
    required: true
  }
});
Builder.createAndAttachToType(CreateCardInvitationResponse.Error);
/**
 * SOURCE ErrorType @ squareup/bbfrontend/v1/client_service.proto at 90:5
 */
CreateCardInvitationResponse.Error.ErrorType = $root.lookupEnum('squareup.bbfrontend.service.v1.CreateCardInvitationResponse.Error.ErrorType').values;
/**
 * SOURCE DebitCardActivationUpsellRequest @ squareup/bbfrontend/v1/client_service.proto at 105:1
 */
export const DebitCardActivationUpsellRequest = $root.lookupType('squareup.bbfrontend.service.v1.DebitCardActivationUpsellRequest');
fixType(DebitCardActivationUpsellRequest);
Builder.createAndAttachToType(DebitCardActivationUpsellRequest);
/**
 * SOURCE DebitCardActivationUpsellResponse @ squareup/bbfrontend/v1/client_service.proto at 110:1
 */
export const DebitCardActivationUpsellResponse = $root.lookupType('squareup.bbfrontend.service.v1.DebitCardActivationUpsellResponse');
fixType(DebitCardActivationUpsellResponse, {
  upsellTitle: {
    notEmpty: true
  },
  buttonTitle: {
    notEmpty: true
  },
  countryCode: {
    required: true
  },
  viewLogEvent: {
    required: true
  },
  clickLogEvent: {
    required: true
  }
});
Builder.createAndAttachToType(DebitCardActivationUpsellResponse);
/**
 * SOURCE ActivatableCard @ squareup/bbfrontend/v1/client_service.proto at 127:3
 */
DebitCardActivationUpsellResponse.ActivatableCard = $root.lookupType('squareup.bbfrontend.service.v1.DebitCardActivationUpsellResponse.ActivatableCard');
fixType(DebitCardActivationUpsellResponse.ActivatableCard, {
  unitToken: {
    notEmpty: true
  },
  activatableCardToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DebitCardActivationUpsellResponse.ActivatableCard);
/**
 * SOURCE DebitCardManagementConfigurationRequest @ squareup/bbfrontend/v1/client_service.proto at 133:1
 */
export const DebitCardManagementConfigurationRequest = $root.lookupType('squareup.bbfrontend.service.v1.DebitCardManagementConfigurationRequest');
fixType(DebitCardManagementConfigurationRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DebitCardManagementConfigurationRequest);
/**
 * SOURCE DebitCardManagementConfigurationResponse @ squareup/bbfrontend/v1/client_service.proto at 165:1
 */
export const DebitCardManagementConfigurationResponse = $root.lookupType('squareup.bbfrontend.service.v1.DebitCardManagementConfigurationResponse');
fixType(DebitCardManagementConfigurationResponse, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DebitCardManagementConfigurationResponse);
/**
 * SOURCE Onboard @ squareup/bbfrontend/v1/client_service.proto at 177:3
 */
DebitCardManagementConfigurationResponse.Onboard = $root.lookupType('squareup.bbfrontend.service.v1.DebitCardManagementConfigurationResponse.Onboard');
fixType(DebitCardManagementConfigurationResponse.Onboard, {
  title: {
    notEmpty: true
  },
  product: {
    required: true
  },
  splash: {
    required: true
  }
});
Builder.createAndAttachToType(DebitCardManagementConfigurationResponse.Onboard);
/**
 * SOURCE Product @ squareup/bbfrontend/v1/client_service.proto at 183:5
 */
DebitCardManagementConfigurationResponse.Onboard.Product = $root.lookupEnum('squareup.bbfrontend.service.v1.DebitCardManagementConfigurationResponse.Onboard.Product').values;
/**
 * SOURCE Manage @ squareup/bbfrontend/v1/client_service.proto at 189:3
 */
DebitCardManagementConfigurationResponse.Manage = $root.lookupType('squareup.bbfrontend.service.v1.DebitCardManagementConfigurationResponse.Manage');
fixType(DebitCardManagementConfigurationResponse.Manage, {
  cardData: {
    required: true
  }
});
Builder.createAndAttachToType(DebitCardManagementConfigurationResponse.Manage);
/**
 * SOURCE CreditCardHomeConfigurationRequest @ squareup/bbfrontend/v1/client_service.proto at 202:1
 */
export const CreditCardHomeConfigurationRequest = $root.lookupType('squareup.bbfrontend.service.v1.CreditCardHomeConfigurationRequest');
fixType(CreditCardHomeConfigurationRequest);
Builder.createAndAttachToType(CreditCardHomeConfigurationRequest);
/**
 * SOURCE CreditCardHomeConfigurationResponse @ squareup/bbfrontend/v1/client_service.proto at 206:1
 */
export const CreditCardHomeConfigurationResponse = $root.lookupType('squareup.bbfrontend.service.v1.CreditCardHomeConfigurationResponse');
fixType(CreditCardHomeConfigurationResponse);
Builder.createAndAttachToType(CreditCardHomeConfigurationResponse);
/**
 * SOURCE CreditCardHomeAvailabilityRequest @ squareup/bbfrontend/v1/client_service.proto at 225:1
 */
export const CreditCardHomeAvailabilityRequest = $root.lookupType('squareup.bbfrontend.service.v1.CreditCardHomeAvailabilityRequest');
fixType(CreditCardHomeAvailabilityRequest);
Builder.createAndAttachToType(CreditCardHomeAvailabilityRequest);
/**
 * SOURCE CreditCardHomeAvailabilityResponse @ squareup/bbfrontend/v1/client_service.proto at 227:1
 */
export const CreditCardHomeAvailabilityResponse = $root.lookupType('squareup.bbfrontend.service.v1.CreditCardHomeAvailabilityResponse');
fixType(CreditCardHomeAvailabilityResponse);
Builder.createAndAttachToType(CreditCardHomeAvailabilityResponse);
/**
 * SOURCE ExistingCreditCard @ squareup/bbfrontend/v1/client_service.proto at 233:3
 */
CreditCardHomeAvailabilityResponse.ExistingCreditCard = $root.lookupType('squareup.bbfrontend.service.v1.CreditCardHomeAvailabilityResponse.ExistingCreditCard');
fixType(CreditCardHomeAvailabilityResponse.ExistingCreditCard, {
  creditLineId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreditCardHomeAvailabilityResponse.ExistingCreditCard);
/**
 * SOURCE Offer @ squareup/bbfrontend/v1/client_service.proto at 237:3
 */
CreditCardHomeAvailabilityResponse.Offer = $root.lookupType('squareup.bbfrontend.service.v1.CreditCardHomeAvailabilityResponse.Offer');
fixType(CreditCardHomeAvailabilityResponse.Offer);
Builder.createAndAttachToType(CreditCardHomeAvailabilityResponse.Offer);
/**
 * SOURCE CreditCardBankingHomeSectionRequest @ squareup/bbfrontend/v1/client_service.proto at 243:1
 */
export const CreditCardBankingHomeSectionRequest = $root.lookupType('squareup.bbfrontend.service.v1.CreditCardBankingHomeSectionRequest');
fixType(CreditCardBankingHomeSectionRequest);
Builder.createAndAttachToType(CreditCardBankingHomeSectionRequest);
/**
 * SOURCE CreditCardBankingHomeSectionResponse @ squareup/bbfrontend/v1/client_service.proto at 245:1
 */
export const CreditCardBankingHomeSectionResponse = $root.lookupType('squareup.bbfrontend.service.v1.CreditCardBankingHomeSectionResponse');
fixType(CreditCardBankingHomeSectionResponse);
Builder.createAndAttachToType(CreditCardBankingHomeSectionResponse);
/**
 * SOURCE CardManagementConfigurationRequest @ squareup/bbfrontend/v1/client_service.proto at 254:1
 */
export const CardManagementConfigurationRequest = $root.lookupType('squareup.bbfrontend.service.v1.CardManagementConfigurationRequest');
fixType(CardManagementConfigurationRequest);
Builder.createAndAttachToType(CardManagementConfigurationRequest);
/**
 * SOURCE CreditCard @ squareup/bbfrontend/v1/client_service.proto at 280:3
 */
CardManagementConfigurationRequest.CreditCard = $root.lookupType('squareup.bbfrontend.service.v1.CardManagementConfigurationRequest.CreditCard');
fixType(CardManagementConfigurationRequest.CreditCard);
Builder.createAndAttachToType(CardManagementConfigurationRequest.CreditCard);
/**
 * SOURCE ClientCapabilities @ squareup/bbfrontend/v1/client_service.proto at 287:5
 */
CardManagementConfigurationRequest.CreditCard.ClientCapabilities = $root.lookupType('squareup.bbfrontend.service.v1.CardManagementConfigurationRequest.CreditCard.ClientCapabilities');
fixType(CardManagementConfigurationRequest.CreditCard.ClientCapabilities);
Builder.createAndAttachToType(CardManagementConfigurationRequest.CreditCard.ClientCapabilities);
/**
 * SOURCE CardManagementConfigurationResponse @ squareup/bbfrontend/v1/client_service.proto at 297:1
 */
export const CardManagementConfigurationResponse = $root.lookupType('squareup.bbfrontend.service.v1.CardManagementConfigurationResponse');
fixType(CardManagementConfigurationResponse);
Builder.createAndAttachToType(CardManagementConfigurationResponse);
/**
 * SOURCE Manage @ squareup/bbfrontend/v1/client_service.proto at 307:3
 */
CardManagementConfigurationResponse.Manage = $root.lookupType('squareup.bbfrontend.service.v1.CardManagementConfigurationResponse.Manage');
fixType(CardManagementConfigurationResponse.Manage);
Builder.createAndAttachToType(CardManagementConfigurationResponse.Manage);
/**
 * SOURCE ProvisionDigitalWalletRequest @ squareup/bbfrontend/v1/client_service.proto at 313:1
 */
export const ProvisionDigitalWalletRequest = $root.lookupType('squareup.bbfrontend.service.v1.ProvisionDigitalWalletRequest');
fixType(ProvisionDigitalWalletRequest);
Builder.createAndAttachToType(ProvisionDigitalWalletRequest);
/**
 * SOURCE CreditCard @ squareup/bbfrontend/v1/client_service.proto at 325:3
 */
ProvisionDigitalWalletRequest.CreditCard = $root.lookupType('squareup.bbfrontend.service.v1.ProvisionDigitalWalletRequest.CreditCard');
fixType(ProvisionDigitalWalletRequest.CreditCard, {
  cardToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ProvisionDigitalWalletRequest.CreditCard);
/**
 * SOURCE DebitCard @ squareup/bbfrontend/v1/client_service.proto at 330:3
 */
ProvisionDigitalWalletRequest.DebitCard = $root.lookupType('squareup.bbfrontend.service.v1.ProvisionDigitalWalletRequest.DebitCard');
fixType(ProvisionDigitalWalletRequest.DebitCard, {
  cardToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ProvisionDigitalWalletRequest.DebitCard);
/**
 * SOURCE Source @ squareup/bbfrontend/v1/client_service.proto at 335:3
 */
ProvisionDigitalWalletRequest.Source = $root.lookupEnum('squareup.bbfrontend.service.v1.ProvisionDigitalWalletRequest.Source').values;
/**
 * SOURCE ProvisionDigitalWalletResponse @ squareup/bbfrontend/v1/client_service.proto at 343:1
 */
export const ProvisionDigitalWalletResponse = $root.lookupType('squareup.bbfrontend.service.v1.ProvisionDigitalWalletResponse');
fixType(ProvisionDigitalWalletResponse);
Builder.createAndAttachToType(ProvisionDigitalWalletResponse);
/**
 * SOURCE Success @ squareup/bbfrontend/v1/client_service.proto at 344:3
 */
ProvisionDigitalWalletResponse.Success = $root.lookupType('squareup.bbfrontend.service.v1.ProvisionDigitalWalletResponse.Success');
fixType(ProvisionDigitalWalletResponse.Success);
Builder.createAndAttachToType(ProvisionDigitalWalletResponse.Success);
/**
 * SOURCE Failure @ squareup/bbfrontend/v1/client_service.proto at 350:3
 */
ProvisionDigitalWalletResponse.Failure = $root.lookupType('squareup.bbfrontend.service.v1.ProvisionDigitalWalletResponse.Failure');
fixType(ProvisionDigitalWalletResponse.Failure);
Builder.createAndAttachToType(ProvisionDigitalWalletResponse.Failure);
/**
 * SOURCE BbFrontendClientService @ squareup/bbfrontend/v1/client_service.proto at 358:1
 */
export const BbFrontendClientService = $root.lookupService('squareup.bbfrontend.service.v1.BbFrontendClientService');